@if (derivativeEntries?.length) {
  <div class="udex-px-24 udex-pt-20">
    <h3 class="heading__medium--xxxxs">{{ 'checkout.additionalSolutions' | cxTranslate }}</h3>
    @for (entry of derivativeEntries; track entry) {
      <div class="mt-4">
        <div class="d-flex flex-nowrap justify-content-between">
          <div class="body--s">
            {{ entry.product.name }}
            {{ 'common.braces' | cxTranslate: {parameter: entry?.product?.supplierAlternativeAID} }}
          </div>
          <div class="heading__regular--xxxs text-nowrap">{{ dcpOrderEntryService.getSubtotal(entry) }}</div>
        </div>
      </div>
    }
  </div>
}
